export function numericKeysOnlyWithDecimalPoint(event): boolean {
	const charCode = event.which ? event.which : event.keyCode;
	if ((charCode >= 48 && charCode <= 57) || charCode === 46) {
		return true;
	}
	return false;
}
